export default {
  group: {
    groupNo: '分类编码',
    groupName: '分类名称',
    status: '状态',
    remarks: '备注',
    addByName: '创建人员',
    adddate: '创建时间',
    updateByName: '更改人员',
    upddate: '更改时间'
  },
  parasettings: {
    placeholder: '参数名称/参数值/参数说明',
    paraName: '参数名称',
    paraValue: '参数值',
    paraDesc: '参数说明',
    remarks: '备注'
  },
  srmsupplierprotocol: {
    protocolName: '注册协议名称',
    adddate: '创建时间',
    upddate: '更新时间',
    edit: '编辑',
    protocolNameplaceholder: '请输入注册协议名称'
  },
  docrule: {
    searchPlaceholder: '输入前缀进行搜索',
    docType: '单据类别',
    prefix: '编码前缀',
    encodingStyle: '编码方式',
    flowNoLength: '流水号位数',
    initialFlowNo: '流水号初始值',
    nowFlowNo: '流水号当前值',
    nextFlowNo: '流水号下一值',
    example: '范例',
    remarks: '备注',
    getExample: '获取范例'
  },
  templateUpload: {
    searchPlaceholder: '请输入模版名称进行搜索',
    reportKey: '模板名称',
    reportType: '模板类型',
    status: '模板状态',
    statusOptions: ['启用', '停用'],
    reportTypeOptions: ['普通报表', '标签'],
    designStorePath: '模板路径',
    fileList: '模版'
  },
  quartz: {
    searchPlaceholder: '请输入任务名',
    statusOptions: ['不存在', '正常', '暂停', '完成', '错误', '阻塞'],
    isStartOptions: ['否', '是'],
    executeStateOptions: ['失败', '成功'],
    jobName: '任务名',
    jobGroup: '任务组名',
    cron: '时间表达式',
    jobClass: '执行类入口',
    state: '状态',
    isStart: '是否启动',
    startTime: '最近一次执行开始时间',
    endTime: '最近一次结束时间',
    nextTime: '下一次开始时间',
    desccription: '定时任务描述',
    failTimes: '定时任务失败次数',
    executeNum: '每次执行笔数',
    executeState: '定时任务执行结果',
    start: '启动',
    pause: '暂停'
  },
  commit: {
    docType: '单据类型',
    successSign: '成功否',
    docNo: '单号',
    errorReason: '错误原因',
    adddate: '提交时间',
    commit: '提交',
    docTypeOptions: ['对账抛转', '收货', '取消收货', '供货比例抛转', '核价抛转', '归还确认抛转'],
    message: '查看报文',
    commitMessage: '是否提交？'
  },
  templateManage: {
    searchPlaceholder: '请输入模版名称进行搜索',
    templateName: '模板名称',
    reportType: '模板类型',
    status: '是否启用',
    addByName: '创建者',
    statusOptions: ['启用', '停用'],
    reportKind: '对应功能',
    reportId: '模板',
    statusName: '模板状态',
    designStorePath: '模板路径',
    publicType: '模板类型',
    warningTip: '模版状态为停用，请检查'
  },
  template: {
    maintain: '关系维护',
    searchPlaceholder: '供应商编号/供应商名称',
    templateStatusOptions: ['启用', '停用'],
    templateId: '订单模板',
    templateStatus: '订单模板状态',
    supOfficeId: '供应商',
    relieve: '关系解除'
  },
  purpurchaseunit: {
    tabOptions: ['停用', '启用'],
    purchaseunit: '采购中心',
    purchaseUnitNo: '采购中心编码',
    purchaseUnitName: '采购中心名称',
    factoryEnableSign: '是否启用工厂',
    factoryEnableSign1: '启用',
    factoryEnableSign0: '停用',
    description: '描述',
    purOfficeName: '结算机构',
    usingFlag: '启用状态',
    usingFlag1: '启用',
    usingFlag0: '停用',
    searchPlaceholder: '输入料号进行搜索',
    throw: '抛转ERP',
    transferSignMes: '存在已抛转单据，请重新选择',
    edition: '版本',
    goodsNo: '料号',
    gotime: '开始时间',
    stoptime: '结束时间',
    goodsName: '品名',
    spec: '规格',
    transferSign: '抛转状态',
    addTitle: '新增供货比例',
    tableTitle: '工厂明细',
    supOfficeNo: '供应商',
    purchaseRatio: '供货比例（%）',
    supOfficeNoRequired: '请选择供应商',
    purchaseRatioMes: '供货比例（%）总和不等于100',
    detailTitle: '供货比例详情',
    currentRatio: '当前供货比例',
    historyRatio: '历史供货比例',
    effectiveDate: '生效日期',
    invalidDate: '失效日期',
    remarks: '备注',
    historicalVersion: '历史版本{edition}',
    factoryName: '工厂',
    settleOfficeName: '结算机构',
    factoryNameRequired: '请选择工厂',
    settleOfficeNameRequired: '请选择结算机构'
  },
  customManagement: {
    searchPlaceholder: '请输入模组',
    sysFlagOptions: ['标准', '客制'],
    fieldNoOptions: ['standardCol01', 'standardCol02', 'standardCol03'],
    fieldTypeOptions: ['文本', '数值', '日期'],
    isDisplayOptions: ['否', '是'],
    displayPageOptions: ['查询条件', '查询列表', '表单头', '表单身', '表单子身'],
    module: '模组',
    fieldNo: '栏位编号',
    fieldName: '栏位名称',
    sysFlag: '系统标记',
    requiredModule: '请选择模组',
    designTable: '表名',
    requiredDesignTable: '请输入表名',
    requiredFieldNo: '请输入',
    fieldNoName: '栏位名称',
    fieldType: '元件类型',
    isDisplay: '界面显示',
    displayPage: '显示位置',
    displayOrder: '显示排序',
    isRequired: '界面必填',
    defaultValue: '默认值',
    fieldType1: '文本',
    fieldType2: '数字',
    fieldType3: '日期',
    displayPage1: '查询条件',
    displayPage2: '查询列表',
    displayPage3: '表单头',
    displayPage4: '表单身',
    displayPage5: '表单子身',
    sysFlag1: '标准',
    sysFlag2: '客制'
  }
}
